import React from 'react';
import PropTypes from 'prop-types';
import {
    WidgetErrorMessage,
    getMetricSourceForRequest,
    allMetricSourcesAuthorized,
    hasMetricSourcesAndData,
} from 'smartsuite-dashboard-app';
import AdvancedSearchLinkTable from './AdvancedSearchLinkTable';

/* eslint-disable complexity */
function getMetricSource({ metricRequests, metrics }) {
    if (metricRequests.length === 0) {
        return { errorKey: 'invalidMetricRequests' };
    }

    const metricSource = getMetricSourceForRequest(metrics, metricRequests[0]);
    if (!metricSource) {
        return { errorKey: 'metricSourceNotFound' };
    }

    if (!allMetricSourcesAuthorized([metricSource])) {
        return { errorKey: 'metricSourceUnauthorized' };
    }

    if (!hasMetricSourcesAndData([metricSource])) {
        return { errorKey: 'missingData' };
    }

    return { metricSource, metricRequest: metricRequests[0] };
}
/* eslint-enable complexity */

export default function AdvancedSearchLinkTableWrapper(props) {
    const { metricSource, metricRequest, errorKey } = getMetricSource(props);

    if (errorKey) {
        return (
            <WidgetErrorMessage>
                {props.dashboardLabels[errorKey]}
            </WidgetErrorMessage>
        );
    }

    return (
        <>
            {metricSource.isTruncated && (
                <div className="truncation-warning">
                    {`${props.dashboardLabels.truncationWarning} ${metricRequest.truncationThreshold}`}
                </div>
            )}
            <AdvancedSearchLinkTable
                {...props} // eslint-disable-line react/jsx-props-no-spreading
                data={metricSource.metricSeries}
                formatValue={props.numberDecimalFormatter}
                timeAndPrecision={metricRequest.timeAndPrecision}
                filterValues={metricRequest.filters}
                whereClauses={metricRequest.where}
            />
        </>
    );
}

AdvancedSearchLinkTableWrapper.propTypes = {
    dashboardLabels: PropTypes.instanceOf(Object).isRequired,
    numberDecimalFormatter: PropTypes.func.isRequired,
};
